import getDefaultLocale from '~/utils/get-default-locale/get-default-locale';

export const defaultState: Fields = {
  locale: getDefaultLocale(),
};

export interface Fields {
  locale: string;
}
